import { ObjectValues } from 'helpers/types';

export const PDF_UPLOAD_STATUS = {
  SUCCESS: 'success',
  FAIL: 'fail',
} as const;

export type IPDFUploadStatus = ObjectValues<typeof PDF_UPLOAD_STATUS>;

export interface IPDFStatusModalProps {
  status: IPDFUploadStatus;
  onClose: VoidFunction;
  onFileUpload: VoidFunction;
  onViewDoc: VoidFunction;
}

export interface IPDFStatusModalButton {
  title: string;
  clickHandler: () => void;
  // TODO: add button variants variants from mui
  variant?: 'outlined' | 'contained';
  icon?: JSX.Element;
}
